export var ContactCenter = [
    {
        id: '772475b7-0b5c-4091-bbec-20214162aff0',
        name: 'DINAMIZ'
    },
    {
        id: 'f79ba532-73c1-489c-a9e1-63585c7ee94a',
        name: 'Matias'
    },
    {
        id: '8face996-5f30-4c42-946c-2732832ea79b',
        name: 'Los 4'
    },
    {
        id: '58494a83-7979-4fb9-a3c8-17c91aed3ce6',
        name: 'FEBA'
    },
    {
        id: 'e2895857-a957-4f7c-a374-c9cf5e46a634',
        name: 'Banco Macro'
    },
    {
        id: '9b252625-a65a-4312-89e3-dc395faf3f34',
        name: 'Referido por Empleado'
    },
    {
        id: '1331e1fb-5581-4f87-9865-a524b454510b',
        name: 'Maer Soft'
    },
    {
        id: 'fc092d03-0e33-4716-8686-3da2f68eb45e',
        name: 'Sebastian'
    },
    {
        id: '88f065ff-4ee7-4071-a664-5a29d896d7c6',
        name: 'CAU'
    },
    {
        id: 'bf3032be-289f-4684-b118-4cbd67d6963b',
        name: 'Web'
    },
    {
        id: '0d289e98-4189-4feb-9968-e20bd772050d',
        name: 'Adwords'
    },
    {
        id: 'f1b92036-692d-4a7d-a8cd-532865a47f63',
        name: 'Banco Hipotecario'
    },
    {
        id: '67bc0a07-e71d-4331-b5f8-26d583908c2e',
        name: 'Credicoop'
    },
    {
        id: '3f472504-6f38-45f5-8856-0662e015be84',
        name: 'German Linari'
    },
    {
        id: 'd38d01f0-6c91-4ad3-97a5-96c8f24beef7',
        name: 'IRSA'
    },
    {
        id: '76b4a728-f3f3-4fb4-8463-262967e5e211',
        name: 'NPS'
    },
    {
        id: 'c3400673-6b4b-44f6-95b0-32ab04cff85c',
        name: 'PPM'
    },
    {
        id: 'ea03a1a4-41de-4179-b36e-613aed33cf0a',
        name: 'AllSale'
    },
    {
        id: '0c11e58d-1ea1-4a84-8fca-6982a6d9fff3',
        name: 'GXC'
    },
    {
        id: 'ad405d4e-d30c-4aab-856a-f1f4d68778f5',
        name: 'Martin Morandi'
    },
    {
        id: '425a8e4b-aee3-4090-93da-4b7d4081807e',
        name: 'CloudBlue'
    },
    {
        id: '446ac7d2-148a-4716-8a84-915a3e6a12dd',
        name: 'Increase SaaS'
    },
    {
        id: '097d340e-415e-45a1-99c5-a578c29df0cc',
        name: 'Mendoza'
    },
    {
        id: '813d616f-c2d5-45ca-832e-d577c49d5323',
        name: 'Banco Comafi'
    },
    {
        id: 'c92134c5-651c-4876-af43-a74a6ef0673c',
        name: 'CABA'
    },
    {
        id: '4b193817-0088-4b01-a44e-42f8c91efe5f',
        name: 'Referido Por C - Level'
    },
    {
        id: '9dee6ffb-04ce-40cf-846e-bc78fb4f7bb2',
        name: 'Fidely'
    },
    {
        id: '4977b180-d490-49a2-aa01-e40b4563c19a',
        name: 'Jimmy'
    },
    {
        id: 'd580baed-afbf-4b32-9f10-c673c02f89a0',
        name: 'Mariano - Zoologic'
    },
    {
        id: 'fd4fde04-2a2b-4288-8e28-dffe2bdf81bc',
        name: 'Misiones'
    },
    {
        id: '33543702-53ec-4948-97cc-820e51bca0b8',
        name: 'Captia'
    },
    {
        id: 'c11bdd04-c9ff-4cce-b9de-1dbc247d093c',
        name: 'Brinks'
    },
    {
        id: '504829db-f57f-4efa-8e12-0d3a818fc8ab',
        name: 'Banco de Comercio'
    },
    {
        id: 'ed2379b9-2c1a-4d72-a51c-39faf32292d4',
        name: 'Comercial Group'
    },
    {
        id: '591cdce6-2346-44c1-a2e2-f0de94bbd017',
        name: 'Frio'
    },
    {
        id: '3293f443-ba4a-4b96-866b-7f18bf1d14c7',
        name: 'Gustavo Oldani'
    },
    {
        id: '439b60b1-2b15-45f4-94db-73a66483677c',
        name: 'MercadoLibre'
    },
    {
        id: '6c0e69a6-9e28-4d6c-a719-b6977edc48e8',
        name: 'Zoologic'
    },
    {
        id: '19d84dd6-1b0e-4d30-a651-f8b52d22d742',
        name: 'PFT'
    },
    {
        id: 'ebc2d13b-4087-466d-ac57-99ecb4629a7e',
        name: 'VN'
    },
    {
        id: '91389a75-6ef8-4b60-9d8f-3c780bce48c2',
        name: 'Andres Luque - Mendoza'
    },
    {
        id: '2735054c-b40a-4e4e-a839-f62f8ddbbab9',
        name: 'Increase-Farming'
    },
    {
        id: '98ce3148-5124-426d-b221-20343c46d30f',
        name: 'ICBC'
    },
    {
        id: '1c84ed3d-8762-44df-a6f0-c58028ae0f70',
        name: 'Galicia'
    },
    {
        id: '8363ee45-36c6-45e9-97c2-37f32e1720f5',
        name: 'Venta Calle'
    },
    {
        id: 'ce33ec2e-94c1-4201-8ea4-ad290a001cac',
        name: 'Aplicateca'
    },
    {
        id: '3b7f4767-d36e-4a2b-8a1f-0ecea9778ece',
        name: 'Marketing'
    },
    {
        id: 'acc12793-a58e-40b3-9d29-b478d19f4fb5',
        name: 'NEA'
    },
    {
        id: '993704ac-043f-4f3b-a198-5b2938e83355',
        name: 'CentroCard'
    },
    {
        id: '2c4dde69-9639-49d8-bcab-9564176a3900',
        name: 'Movistar'
    },
    {
        id: '0402ed80-0a95-49e4-a02d-5f7f7aae43ee',
        name: 'Contadores en la nube'
    },
    {
        id: 'e47172b3-adbf-4ae5-b57f-cb45a8f3d28b',
        name: 'Cordoba'
    },
    {
        id: 'ff86aa4b-cd58-48b9-b835-34d1b9ea6d8e',
        name: 'Banco Comafi Empresas'
    },
    {
        id: '6fe7b3ae-543e-4e95-82d7-7467f8326d3c',
        name: 'CAS'
    },
    {
        id: '18781811-036c-4ef5-9292-9c30382dde65',
        name: 'First Data'
    },
    {
        id: 'b0ac551a-135d-4ba7-8f21-395528980f80',
        name: 'Grupo Vibra'
    },
    {
        id: '8803db0b-6a76-4677-b991-24c746c69b00',
        name: 'Mail en FrÃ\u00ado'
    },
    {
        id: 'be171804-c73f-4a24-bec5-f76885f2c0b9',
        name: 'test'
    },
    {
        id: '554568d9-56af-4d41-a8e0-1a35f81e6695',
        name: 'Cardnet'
    },
    {
        id: '1b397843-eee1-48dd-8bf0-8e7b23772f06',
        name: 'Contactel'
    },
    {
        id: '8645baf8-1043-4cee-b660-709ec68d46be',
        name: 'Redime'
    },
    {
        id: '85b89ba2-ac6f-4fe8-98c2-2da08ea05c4b',
        name: 'Increase-Hunting'
    },
    {
        id: '50f8dc13-8981-45b9-a033-de8cec4f007a',
        name: 'Inlat'
    },
    {
        id: 'd9c1ef15-b45a-40dd-8275-5e10d87539d0',
        name: 'Salta'
    },
    {
        id: '7011e961-ebfd-4215-9fcb-6ebb0d5e75bf',
        name: 'Jorge'
    },
    {
        id: '3cf75248-a5e4-4426-ae54-42591e8361ee',
        name: 'Camara Zona Norte'
    },
    {
        id: '6bcff3d5-f911-45fe-a216-bb2e98f2b024',
        name: 'Referido por Cliente'
    },
    {
        id: '3ae26759-f82a-4b69-a004-6f1744263a73',
        name: 'Fibercorp'
    },
    {
        id: '372f32a3-6562-4d0d-87ca-0579cdc90ddc',
        name: 'Banco Supervielle'
    },
    {
        id: '370d681f-43dd-46c3-92e4-22dbbfde9b29',
        name: 'BBVA'
    },
    {
        id: '561ada31-4847-42e6-adcf-bd462388a5ea',
        name: 'Santa fe'
    },
    {
        id: 'd34cbca9-53a4-43bb-a238-996728481ead',
        name: 'Increase'
    },
    {
        id: '00bafec3-d190-4396-92a4-9b09ff845a1e',
        name: 'Banco Ciudad'
    },
    {
        id: 'ebcc5ffd-b479-49f3-93fe-b3eddc088ee5',
        name: 'Banco Santa Fe'
    },
    {
        id: 'b62f78fb-9433-4f93-8442-a22f372c9c70',
        name: 'DDS'
    },
    {
        id: 'abfa393a-05ab-4cc8-8e87-3ebdcc8a878d',
        name: 'Green Srl'
    },
    {
        id: 'b641ec74-49ca-48e3-91cf-602bc03dbbfe',
        name: 'Juani Arroyo'
    },
    {
        id: 'd0a77404-13a8-4242-bdbf-9f524f65e6f7',
        name: 'On the Spot'
    },
    {
        id: 'c6f31e0b-2080-4778-88db-559c3125bfbf',
        name: 'Banco del Progreso'
    },
    {
        id: 'cca5269a-9547-4928-aa8c-9cc7623fe487',
        name: 'Llamada en frio'
    },
    {
        id: '2c212577-4a96-4dad-9dff-a88185fe0c83',
        name: 'Diners'
    },
    {
        id: '7f303a21-67c3-4262-bf03-72515c8b3e85',
        name: 'ICArgentina'
    },
    {
        id: '63ff681b-c1d6-4144-83d3-64f105abea11',
        name: 'Back-Office'
    }
];
